import { InfoByInn } from '@/types/company/info-by-inn';

import { RequestService } from '../services/request.service';

export const getInfoByInn = async (inn: string) => {
	const request = RequestService.getInstance();

	try {
		const { data } = await request.get<InfoByInn>(`api/v2/companies/by-inn/${inn}/`);

		return data;
	} catch (error) {
		console.error(error);
	}
};
